import { z } from 'zod/v4';

export const bundleSchema = z.object({
  name: z.string(),
  apiKeys: z.array(z.object({ key: z.string() })).optional(),
  description: z.string(),
  bundleId: z.number(),
  apiKeyCount: z.number(),
  applications: z.array(
    z.object({
      name: z.string(),
      configuration: z.array(
        z.object({
          sectionName: z.string(),
          sectionText: z.string(),
        })
      ),
    })
  ),
});

export type Bundle = z.infer<typeof bundleSchema>;
